import { render, staticRenderFns } from "./LevelSettings.vue?vue&type=template&id=4b27bf89&"
import script from "./LevelSettings.vue?vue&type=script&lang=js&"
export * from "./LevelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports